import { useContext, useCallback, useState } from "react";
import { AnchoredModal } from "../../../../components/modal/anchored";
import { Context } from "../../../../context";
import { AddEmployeeModalWrapper } from "./styled";
import { P } from "../../../../components/typography/styled";
import { useEffect } from "react";

export const AddEmployeeModal = ({ handleActionItemClick, anchorElement }) => {
  const { isAddEmployeeModalOpen, setIsAddEmployeeModalOpen } =
    useContext(Context);
  const [modalPosition, setModalPosition] = useState({
    top: "auto",
    right: "var(--cardPadding)",
  });

  const handleCloseModal = useCallback(() => {
    setIsAddEmployeeModalOpen(false);
  }, [setIsAddEmployeeModalOpen]);

  useEffect(() => {
    const handleScroll = () => {
      handleCloseModal();
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleCloseModal]);

  useEffect(() => {
    if (isAddEmployeeModalOpen && anchorElement) {
      const rect = anchorElement.getBoundingClientRect();
      setModalPosition({
        top: `${rect.bottom + 8}px`,
        right: `${window.innerWidth - rect.right}px`,
      });
    }
  }, [isAddEmployeeModalOpen, anchorElement]);

  return (
    <AnchoredModal
      open={isAddEmployeeModalOpen}
      onClose={handleCloseModal}
      className={"add-employee-modal"}
      height={"auto"}
      width={"auto"}
      top={modalPosition.top}
      right={modalPosition.right}
    >
      <AddEmployeeModalWrapper>
        <div
          className="option"
          onClick={(e) => handleActionItemClick(e, "download-template")}
        >
          <P>Download Template</P>
        </div>
        <div
          className="option"
          onClick={(e) => handleActionItemClick(e, "bulk-upload")}
        >
          <P>Upload CSV</P>
        </div>
      </AddEmployeeModalWrapper>
    </AnchoredModal>
  );
};
